import React, { useMemo, useState } from 'react';

import { Footer, Possibility, Features, WhatGPT3, Header } from '../containers';
import { CTA, Brand, Navbar } from '../components';
import SEOMeta from '../components/SEOMeta/SEOMeta';
import {
  generateOrganizationSchema,
  generateLocalBusinessSchema,
  generateFAQSchema,
} from '../utils/seoSchema';
import { useAppTheme } from '../context/AppThemeContext';

import '../App.css';
import HorizontalRowWithMapAndModal from '../containers/MapRow/maprow';
import Carousel from '../components/carousel/carousel';

import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';

const HomePage = () => {
  const { isLightTheme } = useAppTheme();

  return (
    <div className={`App homepage-shell ${isLightTheme ? 'homepage-light' : 'homepage-dark'}`}>
      <SEOMeta
        title="Best Software Training in Bhopal | Algodoor"
        description="Algodoor offers placement-focused software training in Bhopal with practical projects, expert mentors, mock interviews, and career-ready learning."
        url="/"
        type="WebPage"
        image="https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=1200&auto=format&fit=crop&q=80"
        schemaMarkup={{
          '@context': 'https://schema.org',
          '@graph': [
            generateOrganizationSchema(),
            generateLocalBusinessSchema(),
            generateFAQSchema(),
          ],
        }}
      />
      <div className="gradient__bg home-hero-video-shell">
        <HomeHeroVideoPlaylist />
        <div className="home-hero-video-overlay" aria-hidden="true" />
        <div className="home-hero-content">
          <Navbar />
          <Header />
        </div>
      </div>
      <Brand />
      <WhatGPT3 />
      <Features />
      <Possibility />
      <CTA />
      <HorizontalRowWithMapAndModal />
      <Carousel />
      <Footer />
    </div>
  );
};

const HomeHeroVideoPlaylist = () => {
  const sources = useMemo(() => ([
    '/Indian%20students%20in%20classroom%20from%20different%20angle%2C%20working%20on%20computers%20and%20laptops%2C%20screen%20displays%20showing%20ReactJS%2C%20NodeJS%2C%20JavaScript%2C%20Java%2C%20AI%2C%20Fullstack%20development%20code%20and%20interfaces%2C%20dynamic%20learn.mp4',
    '/Indian%20students%20in%20classroom%20sitting%20in%20front%20of%20computers%20and%20laptops%2C%20learning%20software%20development%20and%20web%20development%2C%20preparing%20for%20interviews%2C%20focused%20and%20engaged%20in%20coding.mp4',
  ]), []);
  const [videoIndex, setVideoIndex] = useState(0);

  const handleEnded = () => {
    setVideoIndex((prev) => (prev + 1) % sources.length);
  };

  return (
    <video
      key={sources[videoIndex]}
      className="home-hero-video"
      autoPlay
      muted
      playsInline
      preload="metadata"
      poster="/main-image.png"
      onEnded={handleEnded}
    >
      <source src={sources[videoIndex]} type="video/mp4" />
    </video>
  );
};

export default HomePage;
